import useRipple from "use-ripple-hook";

function Grpc() {
  const [ripple, event] = useRipple();

  return (
    <span className={'tech-icon'} ref={ripple} onMouseDown={event}>
      <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/common/grpc.png'} alt={'grpc'}/>
      Grpc
    </span>
  )
}

export default Grpc;